import { useMutation } from '@tanstack/react-query';
import ChatService from '../services/chat.service';

/**
 * Custom hook to delete a folder using React Query's mutation.
 *
 * @returns An object containing the mutation state and the `mutate` function to trigger the deletion.
 */
export const useDeleteFolder = () => {
    const chatService = new ChatService();

    return useMutation({
        mutationFn: ({
            folderId,
            organizationId,
            recursive,
        }: {
            folderId: string;
            organizationId: string;
            recursive?: boolean;
        }) => chatService.deleteFolder(folderId, organizationId, recursive || false),
    });
};
